import getIn from 'transmute/getIn';
export default getIn;